import { useNetworkStatus } from "@/hooks/useNetworkStatus";
import { nativeAppLabels } from "@/i18n/labels/commonLabels";
import { useLanguage } from "@/context/LanguageContext";

const NativeOfflineBanner = () => {
  const { showOfflineBanner } = useNetworkStatus();
  const { language } = useLanguage();
  const labels = nativeAppLabels(language);

  if (!showOfflineBanner) return null;

  return (
    <div
      className="native-offline-banner fixed left-0 right-0 z-[45] px-4 py-2 text-center text-sm font-medium text-white bg-amber-700"
      role="status"
    >
      {labels.offline ?? "Ingen internetanslutning"}
    </div>
  );
};

export default NativeOfflineBanner;
